import ContentLoader from '@space-core/components/contentLoader'
import styled from 'styled-components'

const TitleLoader = styled(ContentLoader)`
  width: 15rem;
`

const SubTitleLoader = styled(ContentLoader)`
  width: 10rem;
`

const SectionTitleContentLoader = () => {
  return (
    <div
      data-test='section-title-loader'
      className='_d-flex _align-items-center _px-4 _px-md-10 _mb-5'>
      <ContentLoader className='_w-7 _h-7 _overflow-hidden _mr-5 _rounded-lg' />
      <div className='_w-full'>
        <TitleLoader className='_mb-2 _h-4' />
        <SubTitleLoader className='_h-3' />
      </div>
    </div>
  )
}

export default SectionTitleContentLoader
